// store/slices/tripBookingSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TripBookingData } from '../../service/interfaces/Forms';

const initialState: Partial<TripBookingData> = {};

const tripBookingSlice = createSlice({
  name: 'tripBooking',
  initialState,
  reducers: {
    setTripBooking(state, action: PayloadAction<Partial<TripBookingData>>) {
      return { ...state, ...action.payload };
    },
    setFullTripBooking(state, action: PayloadAction<TripBookingData>) {
      return action.payload;
    },
    resetTripBooking() {
      return initialState;
    },
  },
});

export const { setTripBooking, setFullTripBooking, resetTripBooking } = tripBookingSlice.actions;
export default tripBookingSlice.reducer;